import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IGarbageCollectorStatistic } from '../../interfaces/garbage-collector-statistic.interface';

@Component({
    standalone: false,
    selector: 'app-garbage-collector-statistic-dialog',
    templateUrl: './garbage-collector-statistic-dialog.component.html',
    styleUrls: ['./garbage-collector-statistic-dialog.component.scss']
})
export class GarbageCollectorStatisticDialogComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: IGarbageCollectorStatistic) {}

    ngOnInit(): void {}
}
